export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/CarOwnedBySylndr.8b3201a8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};